export const EXTERNAL_LINKS = [
  {
    id: 1,
    title: 'Follow on Facebook',
    href: 'https://www.facebook.com/nakednews',
    icon: 'facebook',
  },
  {
    id: 2,
    title: 'Follow on Twitter',
    href: 'https://twitter.com/nakednews',
    icon: 'twitter',
  },
  {
    id: 3,
    title: 'Follow on Instagram',
    href: 'https://www.instagram.com/thebikinireport/',
    icon: 'instagram',
  },
  {
    id: 5,
    title: 'Follow on Youtube',
    href: 'https://www.youtube.com/@nakednewsbroadcasting',
    icon: 'youtube',
  },
  {
    id: 6,
    title: 'Follow on TikTok',
    href: 'https://www.tiktok.com/@thebikinireport',
    icon: 'tiktok',
  },
  {
    id: 7,
    title: 'Follow on BlueSky',
    href: 'https://bsky.app/profile/nakednews.com',
    icon: 'bluesky',
  },
];
